'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _icon = require('@alicd/next/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderNode = function (_React$Component) {
  (0, _inherits3.default)(OrderNode, _React$Component);

  function OrderNode(props, context) {
    (0, _classCallCheck3.default)(this, OrderNode);
    return (0, _possibleConstructorReturn3.default)(this, (OrderNode.__proto__ || (0, _getPrototypeOf2.default)(OrderNode)).call(this, props, context));
  }

  (0, _createClass3.default)(OrderNode, [{
    key: 'onDragStart',
    value: function onDragStart(e) {
      e.stopPropagation();
      this.props.root.onDragStart(e, this);
      e.dataTransfer.setData('text/plain', 'firefox-need-it');
    }
  }, {
    key: 'onDragEnter',
    value: function onDragEnter(e) {
      e.preventDefault();
      e.stopPropagation();
      this.props.root.onDragEnter(e, this);
    }
  }, {
    key: 'onDragOver',
    value: function onDragOver(e) {
      if (this.props.root.canDrop(this)) {
        e.preventDefault();
        e.stopPropagation();
        this.props.root.onDragOver(e, this);
        return false;
      }
    }
  }, {
    key: 'onDragLeave',
    value: function onDragLeave(e) {
      e.stopPropagation();
      this.props.root.onDragLeave(e, this);
    }
  }, {
    key: 'onDrop',
    value: function onDrop(e) {
      e.preventDefault();
      e.stopPropagation();

      this.props.root.onDrop(e, this);
    }
  }, {
    key: 'deleteHandler',
    value: function deleteHandler(e) {
      e.preventDefault();
      e.stopPropagation();
      this.props.root.deleteHandler(e, this);
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var liProps = {};
      var prefix = 'cn-task-order';
      var _props = this.props,
          className = _props.className,
          dragOver = _props.dragOver,
          dragOverGapTop = _props.dragOverGapTop,
          dragOverGapBottom = _props.dragOverGapBottom,
          draggable = _props.draggable,
          disabled = _props.disabled;

      if (draggable) {
        liProps.onDragEnter = this.onDragEnter.bind(this);
        liProps.onDragOver = this.onDragOver.bind(this);
        liProps.onDragLeave = this.onDragLeave.bind(this);
        liProps.onDrop = this.onDrop.bind(this);
      }

      var liCls = (0, _classnames2.default)((_classNames = {}, (0, _defineProperty3.default)(_classNames, prefix + '-node', true), (0, _defineProperty3.default)(_classNames, prefix + '-node-disabled', disabled), (0, _defineProperty3.default)(_classNames, className, className), (0, _defineProperty3.default)(_classNames, 'cn-drag-draggle', draggable), (0, _defineProperty3.default)(_classNames, 'cn-drag-over', dragOver), (0, _defineProperty3.default)(_classNames, 'cn-drag-over-gap-top', dragOverGapTop), (0, _defineProperty3.default)(_classNames, 'cn-drag-over-gap-bottom', dragOverGapBottom), _classNames));

      var delateTpl = this.props.showDelete ? _react2.default.createElement(_icon2.default, { type: 'minus-r', className: 'cn-task-order-delete', ref: 'deleteRef',
        onClick: this.deleteHandler.bind(this), size: 'small' }) : '';
      var draggleTpl = _react2.default.createElement(_icon2.default, { type: 'view-list', className: 'cn-task-order-move', ref: 'deleteRef',
        onClick: this.props.deleteHandler, size: 'small' });

      return _react2.default.createElement(
        'li',
        (0, _extends3.default)({ ref: 'li' }, liProps, { className: liCls + (this.props.showDelete ? '' : ' cn-task-order-no-delete') }),
        _react2.default.createElement(
          'span',
          { value: this.props.value, className: 'cn-task-order-node-content', draggable: draggable,
            onDragStart: this.onDragStart.bind(this) },
          delateTpl,
          this.props.text,
          draggleTpl
        )
      );
    }
  }]);
  return OrderNode;
}(_react2.default.Component);

OrderNode.propTypes = {
  disabled: _propTypes2.default.bool,
  draggable: _propTypes2.default.bool,
  text: _propTypes2.default.string,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  showDelete: _propTypes2.default.bool,
  root: _propTypes2.default.object,
  onDragStart: _propTypes2.default.func,
  onDragEnter: _propTypes2.default.func,
  onDragOver: _propTypes2.default.func,
  onDragLeave: _propTypes2.default.func,
  onDrop: _propTypes2.default.func,
  deleteHandler: _propTypes2.default.func
};
OrderNode.defaultProps = {
  disabled: false,
  draggable: true,
  text: '',
  showDelete: true,
  onDragStart: function onDragStart() {},
  onDragEnter: function onDragEnter() {},
  onDragOver: function onDragOver() {},
  onDragLeave: function onDragLeave() {},
  onDrop: function onDrop() {},
  deleteHandler: function deleteHandler() {}
};
exports.default = OrderNode;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-task-sorter@0.0.21@@alicd/crui-task-sorter/lib/OrderNode.js
// module id = 719
// module chunks = 0